"use client"

import {Button} from "@/components/ui/button"
import {ExternalLink, Info} from "lucide-react"
import Link from "next/link"
import {useTranslations} from "next-intl"

export function AmazonNotice({ hideButton }: { hideButton?: boolean } = {}) {
    const t = useTranslations("start.amazon")

    return (
        <div className="bg-orange-500/10 border border-muted rounded-lg p-6">
            <div className="flex items-center gap-3">
                <Info className="h-5 w-5 text-foreground flex-shrink-0"/>
                <div className="flex flex-col gap-4">
                    <p className="text-sm text-muted-foreground">
                        {t("noticeText")}
                    </p>
                    {!hideButton && (
                        <Button
                            variant="outline"
                            size="sm"
                            className="self-start"
                            asChild
                        >
                            <Link href="#partnership">
                                <ExternalLink className="h-4 w-4 mr-2"/>
                                {t("noticeButton")}
                            </Link>
                        </Button>
                    )}
                </div>
            </div>
        </div>
    )
}
